import { createSlice } from '@reduxjs/toolkit';
import { ICsaTicketing } from '../types';

const initialState: ICsaTicketing = {
  requestRaised: {
    tickets: [],
    isLoading: false
  },
  requestReceived: {
    tickets: [],
    isLoading: false
  },
  ticket: {
    ticketDetails: {},
    isLoading: false
  }
};

const csaTicketingSlice = createSlice({
  name: 'csaTicketing',
  initialState,
  reducers: {
    setRequestReceived: (state, action) => {
      state.requestReceived.tickets = action.payload;
    },
    setRequestRaised: (state, action) => {
      state.requestRaised.tickets = action.payload;
    },
    setLoadingRequestReceived: (state, action) => {
      state.requestReceived.isLoading = action.payload;
    },
    setLoadingRequestRaised: (state, action) => {
      state.requestRaised.isLoading = action.payload;
    },
    setTicketData: (state, action) => {
      state.ticket.ticketDetails = action.payload;
    },
    setLoadingTicket: (state, action) => {
      state.ticket.isLoading = action.payload;
    }
  }
});

export const {
  setRequestRaised,
  setRequestReceived,
  setLoadingRequestReceived,
  setLoadingRequestRaised,
  setTicketData,
  setLoadingTicket
} = csaTicketingSlice.actions;

export default csaTicketingSlice.reducer;
